<template>
  <div class="field_section--body">
    <grid-row class="field_section--row">
      <grid-column :size="5" class="field_section--row_label">
        {{ fieldMap.label }}
      </grid-column>

      <grid-column :size="1" class="field_section--row_icon">
        <div class="line"></div>
        <icon-default
          class="line-icon"
          icon="right"
        ></icon-default>

        <icon-default
          class="mobile-arrow"
          icon="down"
        ></icon-default>
      </grid-column>

      <grid-column :size="6" class="field_section--row_input">
        <b-field>
          <b-autocomplete
            v-model="input"
            :data="filteredUnusedFields"
            field="fieldLabel"
            :open-on-focus="true"
            placeholder="e.g. submission_field_name"
            icon="magnify"
            keep-first
            @select="selectedField($event)"
            @blur="handleBlur"
          >
            <template #empty>No results for {{ input }}</template>
          </b-autocomplete>
        </b-field>

        <button v-show="input" @click="removeField" class="delete remove-btn"></button>
      </grid-column>
    </grid-row>
  </div>
</template>

<script>
export default {
  name: "WebhookFieldMapping",
  props: {
    fieldMap: {
      type: Object,
      required: true
    },
    fieldMapsData: {
      type: Object,
      required: true
    },
    submission: {
      type: Object,
      required: true
    },
    connection: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      input: this.connection,
      fieldKey: this.connection, // use to keep track on field key map, this.input if for display only
    }
  },
  computed: {
    filteredUnusedFields() {
      return this.unusedFields.filter((option) => {
          return option.label
            .toString()
            .toLowerCase()
            .indexOf(this.input.toLowerCase()) >= 0
      });
    },
    availableFieldMaps() {
      // const fieldMaps = [];
      // const fieldSubmissions = [];

      // for (const [key, value] of Object.entries(this.fieldMapsData)) {
      //   if (value.field_id === null && value.type === null && this.connection !== key) {
      //     fieldMaps.push({
      //       label: key,
      //       value: value,
      //       fieldLabel: key
      //     });
      //   }
      // }
      // console.log('fieldMaps', fieldMaps)

      // for (const [key, value] of Object.entries(this.submission)) {
      //   if (! this.fieldMapsData[key]) {
      //     fieldSubmissions.push({
      //       label: key,
      //       value: value,
      //       fieldLabel: `${key} - ${value}`,
      //     });
      //   }
      // }

      // return [...fieldMaps, ...fieldSubmissions];

      // return all data from the selected submission
      const fieldSubmissions = [];
      for (const [key, value] of Object.entries(this.submission)) {
        fieldSubmissions.push({
          label: key,
          value: value,
          fieldLabel: `${key} - ${value}`,
        });
      }

      return fieldSubmissions;

    },
    unusedFields() {
      const unavailableFieldMaps = Object.keys(this.fieldMapsData);
      const availableFieldMaps = this.$utils.clone(this.availableFieldMaps);

      for (let i = 0; i < unavailableFieldMaps.length; i++) {
        for (let j = 0; j < availableFieldMaps.length; j++) {
          const fieldMap = this.fieldMapsData[unavailableFieldMaps[i]];
          if (fieldMap.field_id !== null && unavailableFieldMaps[i] === availableFieldMaps[j].label) {
            availableFieldMaps.splice(j, 1);
            j--;
          }
        }
      }

      return availableFieldMaps;
    },
  },
  methods: {
    selectedField(field) {
      if (field) {
        this.fieldKey = field.label;
        this.$emit('update', {key: this.fieldKey, info: this.fieldMap.value });
      }
    },
    removeField() {
      this.$emit('update', {key: this.fieldKey, info: {field_id: null, type: null} });
      this.input = '';
      this.fieldKey = '';
    },
    handleBlur() {
      setTimeout(() => {
        if (this.fieldKey !== this.connection) {
          this.$emit('update', {key: this.connection, info: {field_id: null, type: null} });
        }
      }, 500);
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.field_section {
  &--body {
    border-bottom: 1px solid $light-grey;

    &:hover {
      background-color: $background;
    }

    &:nth-last-child(2) {
      border-bottom-width: 0;
    }
  }

  &--row {
    margin-top: 0;
    margin-bottom: 0;
    padding: 0 0.5em;
  }

  &--row_label {
    display: flex;
    align-items: center;
  }

  &--row_icon {
    position: relative;

    .line {
      position: relative;
      top: 50%;
      width: calc(100% - 15px);
      height: 1px;
      background: $primary;
      transform: translate(0, -50%);
      @include mobile {
        display: none;
      }
    }

    .line-icon {
      position: absolute;
      top: 20px;
      right: 15px;
      color: $primary;
      @include mobile {
        display: none;
      }
    }

    .mobile-arrow {
      display: none;
      position: relative;
      width: 100%;
      color: $primary;
      text-align: center;
      @include mobile {
        display: block;
      }
    }
  }

  &--row_input {
    position: relative;

    .field {
      width: calc(100% - 25px);
      margin-bottom: 0;
    }

    .remove-btn {
      position: absolute;
      right: 10px;
      top: 34%;
    }
  }
}
</style>
